import { render, staticRenderFns } from "./CategoryViewSidebar.vue?vue&type=template&id=5b5f5c99&scoped=true&"
import script from "./CategoryViewSidebar.vue?vue&type=script&lang=js&"
export * from "./CategoryViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CategoryViewSidebar.vue?vue&type=style&index=0&id=5b5f5c99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5f5c99",
  null
  
)

export default component.exports